import { useI18n } from '../i18n/i18n';
import { FORMATTER_DEFAULT } from '../market-config/market-formatter';
export function useCurrencyFormatter() {
    const { i18n } = useI18n();
    const formatter = FORMATTER_DEFAULT({ market: 'DE', language: 'de' });
    return {
        formatCurrency: (price, vatConfig = 'hidden', context = 'standard') => {
            if (!price || price.__typename !== 'Price') {
                return '';
            }
            const value = formatter.formatPrice(price.value);
            if (context === 'min-price') {
                return i18n('compareLayer.currency.minPriceWithVAT', { value });
            }
            if (vatConfig === 'inclusive') {
                return i18n('compareLayer.currency.priceWithVAT', { value });
            }
            if (vatConfig === 'exclusive') {
                return i18n('compareLayer.currency.priceExcludingVAT', { value });
            }
            if (vatConfig === 'hidden') {
                return value;
            }
            return i18n('compareLayer.currency.priceWithOptionalVAT', { value });
        },
        formatMonthlyRate: (rate) => {
            if (!rate) {
                return '';
            }
            const value = formatter.formatPrice(rate);
            return i18n('compareLayer.currency.monthlyRate', { value });
        },
        currency: () => {
            return formatter.currency();
        },
    };
}
